<template>
  <div class="c-item">
    <span class="c-last-study-icon" v-if="item.study">上次学到</span>
    <div class="c-title ohidden" :class="chapter ?'chapter' : ''">{{item.name}}</div>
    <div class="c-info">
      <span class="c-type">{{constants.articleType[item.materialType]}}</span>
      <span
        class="c-time"
        v-if="item.materialType!=0"
      >{{item.duration?secondFormat(item.duration.toFixed()):'--'}}</span>
      <!-- <span class="c-time" v-else>
        开课时间：{{item.taskStart ? formatDate(item.taskStart, 'MM.dd'):'-.-'}}
        <span>{{item.taskStart ? formatDate(item.taskStart, 'hh:mm'): '-:-'}}</span>
      </span>-->
      <span class="c-progress" v-if="item.progress != null">
        <span class="pl10 pr5">|</span>
        {{formatProgress(item.progress)}}
      </span>
    </div>
    <div class="c-try" v-if="!item.lock && !$parent.lessonInfo.readPermission">试看</div>
  </div>
</template>

<script>
import { secondsFormatCn } from '@/utils/common.js'
import dates from '@/utils/dates'
export default {
  props: {
    chapter: {
      type: Boolean,
      default: false,
    },
    item: {
      type: Object,
      default() {
        return {}
      },
    },
  },
  methods: {
    secondFormat(time) {
      return secondsFormatCn(time)
    },
    formatDate(time, format) {
      return dates.formatDate(time, format)
    },
    formatProgress(p) {
      let res = ''
      if (p > 0) {
        if (p < 90) {
          res = '已学习' + p + '%'
        } else {
          res = '已学完'
        }
      } else {
        res = '未开始'
      }
      return res
    },
  },
}
</script>

<style lang="less" scoped>
.c-item {
  padding: 6px 0 30px;
  position: relative;
  border-bottom: 1px solid #eee;
  .c-last-study-icon {
    position: absolute;
    width: 104px;
    line-height: 32px;
    background: #fe7700;
    border-radius: 0px 0px 8px 8px;
    font-size: 20px;
    font-weight: 400;
    color: #ffffff;
    top: 0;
    right: 0;
    text-align: center;
  }
  .c-title {
    width: 556px;
    font-size: 30px;
    color: #333333;
    line-height: 40px;
    max-height: 80px;
    margin: 15px 0;
    text-align: justify;
    &.chapter {
      width: 556px;
    }
  }
  .c-type {
    display: inline-block;
    width: 72px;
    line-height: 34px;
    border-radius: 6px;
    border: 2px solid #aaaaaa;
    font-size: 22px;
    color: #888888;
    text-align: center;
  }
  .c-try {
    font-size: 26px;
    color: #ff5500;
    line-height: 1;
    position: absolute;
    z-index: 1;
    top: 30px;
    right: 5px;
  }
  .c-time {
    width: 102px;
    line-height: 34px;
    font-size: 24px;
    color: #888888;
    padding-left: 20px;
    span {
      padding-left: 20px;
    }
  }
  .c-progress {
    font-size: 24px;
    color: #888888;
  }
}
</style>